// src/theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        primary: {
            main: "#1a4d8f",        // Bleu glacier
            dark: "#0f2a4a",        // Bleu nuit
            light: "#4f7bbd",
        },
        secondary: {
            main: "#e63946",        // Rouge dynamique
            dark: "#b72c36",
        },
        background: {
            default: "#f5f7fa",     // Gris neige
            paper: "#ffffff",
        },
        text: {
            primary: "#0f1a2a",
            secondary: "#4a5568",
        },
    },

    typography: {
        fontFamily: "'Inter', 'Roboto', sans-serif",

        h2: {
            fontWeight: 700,
            fontSize: "2.6rem",
            letterSpacing: "-0.5px",
            marginBottom: "1.5rem",
        },

        h3: {
            fontWeight: 700,
            fontSize: "2.2rem",
            letterSpacing: "-0.5px",
            marginBottom: "1.2rem",
        },

        h4: {
            fontWeight: 700,
            fontSize: "1.8rem",
            letterSpacing: "-0.3px",
            marginBottom: "1rem",
        },

        h5: {
            fontWeight: 600,
            fontSize: "1.35rem",
            marginBottom: "0.8rem",
        },

        body1: {
            fontSize: "1.1rem",
            lineHeight: 1.7,
        },

        body2: {
            fontSize: "1rem",
            lineHeight: 1.6,
        },
    },

    components: {
        MuiContainer: {
            styleOverrides: {
                root: {
                    maxWidth: "1100px !important",   // Largeur premium
                    paddingLeft: "24px",
                    paddingRight: "24px",
                },
            },
        },

        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: "#ffffff",
                    borderRadius: "16px",
                    border: "1px solid #e5e7eb",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                    transition: "all 0.3s ease",
                },
            },
        },

        MuiButton: {
            styleOverrides: {
                root: {
                    padding: "10px 26px",
                    borderRadius: "10px",
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: "1rem",
                    transition: "all 0.25s ease",
                    "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
                    },
                },
            },
        },
    },

    // Styles personnalisés réutilisables
    custom: {
        gradient: "linear-gradient(135deg, #1a4d8f 0%, #0f2a4a 100%)",

        section: {
            paddingTop: "64px",
            paddingBottom: "64px",
        },

        sectionTitle: {
            fontSize: "2rem",
            fontWeight: 700,
            color: "#1a4d8f",
            textAlign: "center",
            marginBottom: "24px",
        },

        cardHover: {
            "&:hover": {
                transform: "translateY(-4px)",
                boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                borderColor: "#d0d0d0",
            },
        },
    },
});

export default theme;
